/* eslint-disable @typescript-eslint/member-ordering */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef, EventEmitter, Output, ViewChild, OnDestroy, ViewChildren, QueryList, ElementRef, Renderer2 } from '@angular/core';
import { ResultsSearchService } from '../home/results-search.service';
import { TitleFilterPipe } from '../shared/titleFilter.pipe';
import { RestService } from '../shared/rest.service';
import { ResultsMultidestinations } from './category-result/results.multidestinations';
import { PayloadCategoryMultidestinations } from './category-result/payload.category';
import { Procesed } from '../shared/enum-procesed';
import { ItineraryService } from '../shared/itinerary.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalLoadingComponent } from '../shared/modal-loading/modal-loading.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../shared/modals/confirmation-modal/confirmation-modal.component';
import { UserService } from '../pages/com.usblick.common/auth/user.service';
import { PACKAGES } from '../home/search-box/categories/packages/response/searchResponsepackages';
import { CategoryResultComponent } from './category-result/category-result.component';
import { Observable, Subject, Subscription } from 'rxjs';
import { setting } from '../../../setting';
import { distinctUntilChanged, map, take, takeUntil } from 'rxjs/operators';
import { HotelsComponent } from 'app/home/search-box/categories/hotels/hotels.component';
import { RentcarsComponent } from 'app/home/search-box/categories/rentcars/rentcars.component';
import { ActivitiesComponent } from 'app/home/search-box/categories/activities/activities.component';
import { TransportsComponent } from 'app/home/search-box/categories/transports/transports.component';
import { MultiDestinationComponent } from 'app/multi-destination/multi-destination.component';
import { InsuranceComponent } from 'app/home/search-box/categories/insurance/insurance.component';
import { HotelService } from 'app/shared/modals/modal-hotel/hotel.service';
import { HotelResultComponent } from './category-result/result/base-result/information/categories/hotel-result/hotel-result.component';
import { BaseResultComponent } from './category-result/result/base-result/base-result.component';
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { RestorePayloadService } from './services/restore-payload.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions } from 'app/core/profiles/profiles.selectors';
import { SuggestionComponent } from 'app/shared/suggestion/suggestion.component';

@Component({
  selector: 'usb-content-result',
  templateUrl: './content-result.component.html',
  styleUrls: ['./content-result.component.scss'],
  providers: [
    TitleFilterPipe
  ]
})

export class ContentResultComponent implements OnInit, OnDestroy {

  @Output() isMultiModal = new EventEmitter<any>();

  @ViewChild('flightsCarousel') flightsCarousel!: ElementRef;
  @ViewChild(CategoryResultComponent) CategoryResultComponent!: CategoryResultComponent;
  @ViewChild(CategoryResultComponent) categoryResult!: CategoryResultComponent;
  @ViewChild('carousel') carouselFilter!: ElementRef;
  @ViewChild('suggestionComponent') suggestionComponent!: SuggestionComponent;
  @ViewChildren('categoryButton') buttons!: QueryList<ElementRef>;
  @ViewChildren('icon', { read: ElementRef }) icons!: QueryList<ElementRef>;
  @ViewChildren(HotelResultComponent) hotelComponents!: QueryList<HotelResultComponent>;

  payloadCategory!: PayloadCategoryMultidestinations;
  resultsMultidestinations!: ResultsMultidestinations;
  modalRef!: BsModalRef;
  group: any;
  _payload: any;
  _results: any;
  _resultPaged: any;
  _origin: string = '';
  _tabSelected: string = '';
  tabSelected: string = '';
  isLoading: boolean = true;
  multiModal: boolean = false;
  text: string = '';
  auxiliarArray: any;
  itinerary: any;
  ori: any;
  pax: number = 0;
  paxAdults: number = 0;
  paxChildren: number = 0;
  payloadForm: any;
  viewMap: boolean = false;
  deleteProduct: string = '';
  config = {
    animated: true,
    keyboard: false,
     backdrop: true,
    ignoreBackdropClick: true
  };
  _actualItinerary: any;
  resultsFound: boolean = false;
  _payloadTransport: any[] = [];
  _applyFilter: any[] = [];
  _emit: boolean = false;
  _contentCollapsed: boolean = true;
  public isCollapsed = {};
  public items: string[] = ['item 1', 'item 2', 'item 3'];
  filtersRentacar: any;

  bsModalRef?: BsModalRef;

  _form: any;

  /// carrusel
  noWrapSlides: boolean = false;
  showIndicator: boolean = true;

  currency_exchange: any[] = [];
  itineraryCurrency: string = '';
  getClientsSettingAppBooking: any;
  formTransports: any;
  openModalFly: boolean = false;
  private searchLocationssubscription!: Subscription;
  private destroy$ = new Subject<void>();
  private previousItemsLength: number | null = null; // << agregá esto en la clase
  styleSidebar: any;
  filterColorIcon: any;
  categoryId: number = -1;
  reloadSearching: boolean = false;
  activeComingSoonIndex: number | null = null;
  openModalResearch: boolean = false;
  currencies: any[] = [];
  currencyAgency: any;
  qtyProductValid: number = -1;
  eventModifiedTransportPriceSelectedReturn: boolean = false;
  paymentConditions: any;
  paymentAgencyActive: any;
  private isRemovingItem: boolean = false;
  arrayFilterAcriss:any[] = [];
  selectedAcrissKey:any = null;

  coordinatesArr: any[] = [];
  pickupLocation: any;
  dropoffLocation: any;
  visualMap: boolean = false;

  filteredFlights: any[] = [];
  allFlights: any[] = [];
  sortedFlights: any[] = [];
currentSort: 'cheapest' | 'fastest' | 'recommended' = 'recommended';
  // Configuración de filtros
  flightFilters = {
    selectedAirlines: new Set<string>(),           // Aerolíneas seleccionadas
    selectedStops: 'todos' as 'directo' | 'unaEscala' | 'dosMasEscalas' | 'todos',
    priceRange: { min: 0, max: 1000000 },          // Rango de precios en USD
    departureTimeRange: { min: 0, max: 24 },       // Horas de salida
    arrivalTimeRange: { min: 0, max: 24 }          // Horas de llegada
  };

// Lista de aerolíneas disponibles para mostrar en checkboxes
availableAirlines: string[] = [];
airlineDetails: { code: string, name: string }[] = []; // DETALLES DE AEROLÍNEAS
showPrevArrow: boolean = false;
showNextArrow: boolean = true;

permissions$: Observable<string[]>;
permissionsMap: { [key: string]: boolean } = {};

  private modalLoadingOpen: boolean = false;

  constructor(
    private modalService: BsModalService,
    private resultsSearch: ResultsSearchService,
    private _restService: RestService,
    private _router: Router,
    private serviceItinerary: ItineraryService,
    private titleFilter: TitleFilterPipe,
    public userService: UserService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private renderer: Renderer2,
    private hotelService: HotelService,
    private restorePayloadService: RestorePayloadService,
    private store: Store<AppState>,
  ) { }


  ngOnInit() {

    this.getPermissions();

    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);

    this.currencies = this.userService.currenciesExchange;

    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));

    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency.currency);

    this.setItinerary();
    // Mostrar spinner brevemente al navegar desde editar búsqueda en summary
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    this._results = this.resultsSearch._getResponse();

    this._payload = this.resultsSearch._getPayload();
    this._origin = this.resultsSearch._getOrigin();
    this._form = JSON.parse(localStorage.getItem('form'));
    let offline = false;

    this.initResultsMultidestination();
    this.initPayloadCategoryMultidestination();

    if (!this._results || !this._payload) {
      //  this._origin = this.getOrigin(this._payload[0].categoriesId[0])
      this._origin = localStorage.getItem('origin');
      this._payload = JSON.parse(localStorage.getItem('payload'));
      offline = true;
    }

    /// ESTO ES TEMPORAL HASTA QUE EXISTA REUSLTADO DE BUSQUEDA DE DYSNEY
    if ((this._origin == "DISNEY") || (this._origin == "PTHEMES")) {
      offline = false;
    }

    if(this._origin === 'TRANSPORTS') {
      this.formTransports = JSON.parse(localStorage.getItem('form'));
    }

    if (this._origin === Procesed.MULTIDESTINATION) {
      this._tabSelected = Procesed.HOTELS;
      this.resultsFound = true;
    } else {
      if (this._results !== undefined && this._results !== null) {
        // eslint-disable-next-line max-len
        this.resultsFound = this._results[0] !== undefined ? this._results[0]['noResultMessage'] !== undefined ? false : true : this._results['noResultMessage'] !== undefined ? false : true;
      }
    }
    if (this._results !== undefined) {
      this.initializeInformationMap(this._results);
      for (let index = 0; index < this._results.length; index++) {
        this.isCollapsed[index] = true;
      }
     }

     if(this._payload && !this._origin) {
        this._origin = this.getOrigin(this._payload[0].categoriesId[0]);
     }

     if(!this._payload && !this._origin) {
        this.notificationService.info('Realice una nueva busqueda');
        this._router.navigateByUrl('home');
     }

    if (offline) {
      switch(this._origin) {

        case 'HOTELS':
          this.loadResult('HOTELS', this._payload);
          break;
        case 'FLIGHTS':
          this.loadResult('FLIGHTS', this._payload);
          break;
        case 'TRANSPORTS':
          this.loadResult('TRANSPORTS', this._payload);
          break;
        case 'TOURS':
          this.loadResult('TOURS', this._payload);
          break;
        case 'INSURANCE':
          this.loadResult('INSURANCE', this._payload);
          break;
        case 'RENT-A-CAR':
          this.loadResult('RENT-A-CAR', this._payload);
          break;
      }
    }
    this.getQtyProductValid();
    //this.getItinerary(this.userService.itineraryActive[0]);

    this.getPaymentConditions(selectedAgency);

  }
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  getPermissions(): void {
    this.permissions$ = this.store.select(selectPermissions);
    this.permissions$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });
  }

    /**
   * Indexa el array de permisos por `permission.name` para acceso O(1).
   * @param permissions Array de permisos desde el store.
   * @returns Mapa de permisos indexado por nombre.
   */
    createPermissionsMap(permissions: any[]): { [key: string]: any } {
      const map: { [key: string]: any } = {};
      permissions.forEach((permission) => {
        map[permission.name] = permission;
      });
      return map;
    }

          getPaymentConditions(agency: any) {
        this._restService.doGet('app', 'agencyPaymentCondition/list?').subscribe({
          next: (response: any) => {
            if(response) {
              this.paymentConditions = response;
              this.availablePaymentConditions(this.paymentConditions, agency);
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log('No existe informacion, Condición de Pagos!', error);
          }
        })
      }

      private availablePaymentConditions(dataPaymentCondition: any, agency: any) {
        const payAgencyActive = dataPaymentCondition.find(c => c.id === agency.pay_mode);
        this.paymentAgencyActive = payAgencyActive;
      }

      getOrigin(categoryId: number): string {
    switch(categoryId) {
      case 1: return 'HOTELS';
      case 2: return 'RENT-A-CAR';
      case 6: case 9: return 'TOURS';
      case 8: return 'TRANSPORTS';
      case 10: return 'INSURANCE';
    }
  }

  get currentCategoryName(): string {
    const id = this._payload && this._payload[0] && this._payload[0].categoriesId && this._payload[0].categoriesId[0];
    return id !== undefined ? this.getOrigin(id) : null;
  }



    getQtyProductValid(): void {
    switch(this._payload[0].categoriesId[0]) {
      case 1:
        this.qtyProductValid = this._payload[0].qtyProduct;
        break;
      case 3:
         this.initializeFlightsData();
         break;
    }
  }

  initializeFlightsData() {
  // IMPORTANTE: flightsData es [Array(140)] según tu log
  if (this._results && this._results.length > 0) {
    // Extraemos el array interno que contiene los 140 vuelos
    this.allFlights = this._results[0] || [];

    // Inicializar resultados filtrados con todos los vuelos
    this.filteredFlights = [...this.allFlights];

    // Extraer aerolíneas únicas
    this.extractUniqueAirlines();

    this.sortFlights('recommended'); // Orden inicial
    setTimeout(() => this.updateCarouselArrows(), 0);

  }
}

extractUniqueAirlines() {
  const airlinesMap = new Map<string, string>();

  this.allFlights.forEach((flight: any) => {
    const airlineData = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline;
    if (airlineData?.code) {
      const name = airlineData.name || airlineData.code;
      airlinesMap.set(airlineData.code, name);
    }
  });

  this.airlineDetails = Array.from(airlinesMap.entries())
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

getFlightStopsCount(flight: any): number {
  const segments = flight?.itinerary?.[0]?.options?.[0]?.segments || [];
  return segments.length - 1; // 0 = directo, 1 = 1 escala, 2+ = múltiples
}

getFlightStopsLabel(flight: any): string {
  const stops = this.getFlightStopsCount(flight);

  switch(stops) {
    case 0: return 'Directo';
    case 1: return '1 escala';
    default: return `${stops} escalas`;
  }
}

toggleAirlineSelection(airlineCode: string) {
  if (this.flightFilters.selectedAirlines.has(airlineCode)) {
    this.flightFilters.selectedAirlines.delete(airlineCode);
  } else {
    this.flightFilters.selectedAirlines.add(airlineCode);
  }
  this.applyFlightFilters();
}

selectAllAirlines() {
  this.flightFilters.selectedAirlines = new Set(this.availableAirlines);
  this.applyFlightFilters();
}

clearAllAirlines() {
  this.flightFilters.selectedAirlines.clear();
  this.applyFlightFilters();
}

setStopsFilter(type: 'directo' | 'unaEscala' | 'dosMasEscalas' | 'todos') {
  this.flightFilters.selectedStops = type;
  this.applyFlightFilters();
}

updatePriceRange(min: number, max: number) {
  this.flightFilters.priceRange = { min, max };
  this.applyFlightFilters();
}

applyFlightFilters() {
  this.filteredFlights = this.allFlights.filter((flight: any) => {

    // 1. FILTRO POR AEROLÍNEA
    if (this.flightFilters.selectedAirlines.size > 0) {
      const flightAirline = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline?.code;
      if (!flightAirline || !this.flightFilters.selectedAirlines.has(flightAirline)) {
        return false;
      }
    }

    // 2. FILTRO POR ESCALAS
    if (this.flightFilters.selectedStops !== 'todos') {
      const stops = this.getFlightStopsCount(flight);
      if (this.flightFilters.selectedStops === 'directo' && stops !== 0) return false;
      if (this.flightFilters.selectedStops === 'unaEscala' && stops !== 1) return false;
      if (this.flightFilters.selectedStops === 'dosMasEscalas' && stops < 2) return false;
    }

    // 3. FILTRO POR PRECIO
    const flightPrice = flight?.passengers?.[0]?.price?.total || flight?.price?.total || 0;
    if (flightPrice < this.flightFilters.priceRange.min ||
        flightPrice > this.flightFilters.priceRange.max) {
      return false;
    }

    return true; // El vuelo pasa todos los filtros
  });

  // ← IMPORTANTE: Mover sort FUERA del filter
  this.sortFlights(this.currentSort);

}


sortFlights(sortType: 'cheapest' | 'fastest' | 'recommended') {
  this.currentSort = sortType;

  switch(sortType) {
    case 'cheapest':
      this.sortedFlights = [...this.filteredFlights].sort((a, b) =>
        this.getFlightPrice(a) - this.getFlightPrice(b)
      );
      break;
    case 'fastest':
      this.sortedFlights = [...this.filteredFlights].sort((a, b) =>
        this.getFlightDuration(a) - this.getFlightDuration(b)
      );
      break;
    case 'recommended':
    default:
      this.sortedFlights = [...this.filteredFlights];
      break;
  }

  // Resetear posición del carrusel
  setTimeout(() => {
    if (this.flightsCarousel) {
      this.flightsCarousel.nativeElement.scrollLeft = 0;
      this.updateCarouselArrows();
    }
  }, 0);
}

// Funciones para el carrusel
scrollCarousel(direction: number) {
  const container = this.flightsCarousel.nativeElement;
  const cardWidth = 200; // Ancho aproximado de cada tarjeta
  const scrollAmount = cardWidth * 2; // Avanzar 2 tarjetas
  container.scrollLeft += direction * scrollAmount;

  setTimeout(() => this.updateCarouselArrows(), 100);
}

updateCarouselArrows() {
  const container = this.flightsCarousel.nativeElement;
  this.showPrevArrow = container.scrollLeft > 5;
  this.showNextArrow = container.scrollLeft < container.scrollWidth - container.clientWidth - 5;
}

// Obtener el precio más bajo por aerolínea y cantidad de escalas
getLowestPriceByAirlineAndStops(airlineCode: string, stopsCount: number): number {
  const flights = this.allFlights.filter(flight => {
    const flightAirline = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline?.code;
    const flightStops = this.getFlightStopsCount(flight);
    return flightAirline === airlineCode && flightStops === stopsCount;
  });

  if (flights.length === 0) return 0;

  const prices = flights.map(f => this.getFlightPrice(f));
  return Math.min(...prices);
}

// Obtener el vuelo más barato
getCheapestFlight(): any {
  if (this.filteredFlights.length === 0) return null;
  return this.filteredFlights.reduce((min, flight) =>
    this.getFlightPrice(flight) < this.getFlightPrice(min) ? flight : min
  );
}

// Obtener el vuelo más rápido
getFastestFlight(): any {
  if (this.filteredFlights.length === 0) return null;
  return this.filteredFlights.reduce((min, flight) =>
    this.getFlightDuration(flight) < this.getFlightDuration(min) ? flight : min
  );
}

// Obtener vuelo recomendado (ejemplo: balance entre precio y duración)
getRecommendedFlight(): any {
  if (this.filteredFlights.length === 0) return null;
  // Lógica personalizada de recomendación
  return this.filteredFlights[0]; // Placeholder
}

// Obtener nombre de aerolínea desde el vuelo
getAirlineNameFromFlight(flight: any): string {
  const airlineData = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline;
  return airlineData?.name || airlineData?.code || 'Desconocida';
}

// Obtener fecha del vuelo
getFlightDate(flight: any): string {
  return flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.departure?.date;
}

// Obtener precio del vuelo
getFlightPrice(flight: any): number {
  return flight?.passengers?.[0]?.price?.total || flight?.price?.total || 0;
}

// Obtener duración del vuelo en minutos
getFlightDuration(flight: any): number {
  return flight?.itinerary?.[0]?.options?.[0]?.duration || 0;
}

resetAllFilters() {
  this.flightFilters = {
    selectedAirlines: new Set<string>(),
    selectedStops: 'todos',
    priceRange: { min: 0, max: 1000000 },
    departureTimeRange: { min: 0, max: 24 },
    arrivalTimeRange: { min: 0, max: 24 }
  };

  this.applyFlightFilters();
}

  qtyProductValidDecrement(): void {
    this.qtyProductValid = this.qtyProductValid - 1;
  }




  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if(this._results.length > 0) {
      this._results = [];
      this._resultPaged = [];
    }
  }

  /**
 * Establece el itinerario actual, ya sea desde el servicio `userService` o llamando al servicio `serviceItinerary` para obtenerlo.
 * Si no hay un itinerario activo, se realiza una suscripción para obtener el itinerario.
 */
  setItinerary() {
    this._actualItinerary = this.userService.itineraryActive[0];

    this.serviceItinerary.getItinerary$().pipe(
      map((data: any) => ({
        fullData: data?.[0],
        id: data?.[0]?.id,
        itemsLength: data?.[0]?.items?.length ?? 0,
        flightsLength: data?.[0]?.flights?.length ?? 0
      })),
      distinctUntilChanged((prev, curr) =>
        prev.id === curr.id &&
        prev.itemsLength === curr.itemsLength &&
        prev.flightsLength === curr.flightsLength // <- compara fly profundo
      ),
      takeUntil(this.destroy$)
    )
    .subscribe((response) => {
      if (response.fullData) {
        this._actualItinerary = response.fullData;
        this.previousItemsLength = response.itemsLength;
      }
    });
  }






 /**
 * Método para almacenar los filtros de Rentacar.
 *
 * Este método se utiliza para almacenar el valor de los filtros de Rentacar
 * en la propiedad `filtersRentacar`.
 *
 * @value -> valor que se almacenará en la propiedad `filtersRentacar`.
 */
_filtersRentacar(value: any) {
  this.filtersRentacar = value;
}

/**
 * Método para aplicar un filtro a los resultados.
 *
 * Este método invoca el método `applyFilter` del componente `CategoryResultComponent`,
 * permitiendo aplicar filtros específicos sobre los resultados.
 *
 * @event -> evento que genera la acción de aplicar el filtro.
 * @value -> valor con el que se aplica el filtro.
 * @category -> categoría a la que se le aplica el filtro.
 * @id -> identificador asociado al filtro que se aplica.
 */
applyFilter(event: any, value: any, category: any, id: any ) {
  this.CategoryResultComponent.applyFilter(event, value, category, id);
}

/**
 * Método para alternar el estado de colapso de un contenido.
 *
 * Este método cambia el estado de la propiedad `_contentCollapsed`, alternando entre
 * verdadero y falso para colapsar o expandir un contenido.
 */
toggleCollapse() {
  this._contentCollapsed = !this._contentCollapsed;
}

/**
 * Método para cerrar o abrir el contenido según el valor proporcionado.
 *
 * Este método ajusta el estado de `_contentCollapsed` según el parámetro `close`,
 * permitiendo controlar si el contenido está colapsado o no.
 *
 * @close -> valor booleano que indica si el contenido debe estar colapsado (true) o expandido (false).
 */
closeCollapse(close: boolean) {
  this._contentCollapsed = close;
}

/**
 * Método para procesar un itinerario y calcular la cantidad de pasajeros.
 *
 * Este método recibe un itinerario, recorre sus destinos y elementos, y calcula el número total
 * de pasajeros (adultos y niños) basándose en la información contenida en los elementos de transporte
 * dentro del itinerario.
 *
 * @itinerary -> objeto que representa el itinerario, con destinos y elementos relacionados.
 */
getItinerary(itinerary: any) {
  this.itinerary = itinerary;

  this.pax = 0;
  this.paxAdults = 0;
  this.paxChildren = 0;
  if (itinerary[0] !== undefined) {
    for (let i = 0; i < itinerary[0].destination.length; i++) {
      const destiny = itinerary[0].destination[i];
      for (let j = 0; j < itinerary[0].items.length; j++) {
        const item = itinerary[0].items[j];
        let payload = item.payloadUpdate && item.payloadUpdate.products ? item.payloadUpdate.products[0] : item.payload;
        if ((item.categoryName === 'TRANSPORTS') && (payload && payload.destination === destiny.iata_code)) {
          this.pax = this.pax + item.paxAdults;
          this.paxAdults = this.paxAdults + item.paxAdults;
          this.paxChildren = this.paxChildren + item.paxChildren;
        }
      }
    }
  }
}

/**
 * Método para actualizar un array y aplicar un filtro si es necesario.
 *
 * Este método recibe un array, lo almacena en la propiedad `auxiliarArray`, y si existe un texto
 * de filtro, lo aplica a los resultados utilizando el transformador `titleFilter`.
 *
 * @array -> nuevo array que reemplaza a la propiedad `auxiliarArray`.
 */
updateArray(array: any) {
  this.auxiliarArray = array;
  this._resultPaged = this.text ? this.titleFilter.transform(this.auxiliarArray, this.text) : this._resultPaged;

  // Si el mapa está visible, refrescarlo con los resultados filtrados
  // para que los filtros aplicados (antes o durante la vista de mapa) se reflejen
  if (this.visualMap && (this._origin === 'HOTELS' || this._origin === 'TOURS')) {
    // HOTELS emite `[[...items]]` desde el hijo (resultPaged = [this.results])
    // TOURS emite `[...items]` (flat); lo envolvemos para mantener la forma
    // que espera initializeInformationMap (source[0] = array de items).
    const mapSource = this._origin === 'TOURS' && !Array.isArray(this.auxiliarArray[0])
      ? [this.auxiliarArray]
      : this.auxiliarArray;
    this.initializeInformationMap(mapSource);
  }
}

/**
 * Maneja el toggle del mapa (Ver Mapa / Ver Lista).
 *
 * Cuando se abre el mapa (event=true), reconstruye coordinatesArr desde
 * auxiliarArray para que muestre los resultados filtrados aplicados
 * previamente. Cuando se cierra (event=false), solo actualiza el flag.
 */
onMapToggle(event: boolean): void {
  this.visualMap = event;

  if (event && (this._origin === 'HOTELS' || this._origin === 'TOURS') && this.auxiliarArray) {
    const mapSource = this._origin === 'TOURS' && !Array.isArray(this.auxiliarArray[0])
      ? [this.auxiliarArray]
      : this.auxiliarArray;
    this.initializeInformationMap(mapSource);
  }
}

  /**
 * Método para redirigir a diferentes rutas según el valor seleccionado.
 *
 * Este método verifica el valor del parámetro `selected` y realiza la redirección correspondiente.
 * Si `selected` es igual a 'SUMMARY', se navega a la ruta `/summary`. De lo contrario, se actualiza
 * la propiedad `_tabSelected` y llama al método `setResultTab`.
 *
 * @selected -> valor que determina la ruta a la que se debe redirigir o el tab seleccionado.
 */
_redirectTo(selected: string) {
  if (this.multiModal) {
    this.modalService._hideModal(1);
  }
  if (selected === 'SUMMARY') {
    this._router.navigate(['/summary']);
  } else {
    if (selected !== 'SUMMARY') {
      this._tabSelected = selected;
      this.setResultTab(selected);
    }
  }
}

/**
 * Método para obtener las ciudades desde una API.
 *
 * Este método realiza una petición GET al endpoint `/searchlocations/{param}` para obtener una lista de ciudades
 * y almacena el nombre de la ciudad en la propiedad `ori`.
 *
 * @param param -> parámetro utilizado en la URL para buscar las ubicaciones.
 */
_getCitys(param: any) {
  this.searchLocationssubscription = this._restService.doGet('api', '/searchlocations/' + param).subscribe(res => {
    return this.ori = res['data'][0]['cityName'];
  },
  Error => {
    console.log('Error', Error);
  });
}

/**
 * Método para seleccionar una pestaña y limpiar el payload de transporte.
 *
 * Este método establece el valor de `tabSelected` como el valor de `selected` y limpia el contenido de la propiedad
 * `_payloadTransport`.
 *
 * @selected -> valor que representa la pestaña seleccionada.
 */
_goTo(selected: string) {
  this.tabSelected = selected;
  this._payloadTransport = [];
}

/**
 * Método para cargar un nuevo payload.
 *
 * Este método establece el valor de la propiedad `payloadForm` con el payload recibido como parámetro.
 *
 * @payload -> objeto de tipo payload que se almacenará en la propiedad `payloadForm`.
 */
loadPaylod(payload: any) {
  this.payloadForm = payload;
}

/**
 * Método para recargar la búsqueda con un nuevo payload.
 *
 * Este método añade un destino al payload, actualiza el formulario de payload y muestra el resultado correspondiente
 * a través de la actualización de los elementos HTML.
 *
 * @payload -> objeto de tipo payload que se añadirá a la búsqueda.
 * @i -> índice utilizado para modificar la visibilidad de los elementos HTML correspondientes.
 */
reloadSearch(payload: any, i: any) {
  this.addDestination(payload);
  this.payloadForm = payload;

  this.payloadCategory.payloadTransport = this._payloadTransport;
  document.getElementById('check-p' + i).style.display = 'none';
  document.getElementById('check-r' + i).style.display = 'block';
}

/**
 * Método para recargar el índice de un destino.
 *
 * Este método cambia el estado de colapso de dos elementos de destino, asegurando que el índice actual se colapse
 * mientras que el siguiente índice se expanda.
 *
 * @index -> índice de la lista de destinos que se está procesando.
 * @i -> índice utilizado para manipular los elementos de la lista.
 */
reloadIndex(index: any, i: any) {
  this.isCollapsed[i] = true;
  this.isCollapsed[i + 1] = false;
}

/**
 * Método para añadir un nuevo destino al array de transporte.
 *
 * Este método verifica si el destino ya existe en la lista `_payloadTransport`. Si es así, lo actualiza con el nuevo
 * valor; de lo contrario, lo agrega como un nuevo elemento en el array.
 *
 * @newItem -> objeto que representa el nuevo destino que se añadirá o actualizará.
 */
addDestination(newItem: any) {
  let _new = false;
  for (let i = 0; i < this._payloadTransport.length; i++) {
    if (this._payloadTransport[i]['origin'] === newItem['origin']) {
      this._payloadTransport[i] = newItem;
      _new = true;
    }
  }
  if (_new === false) {
    this._payloadTransport.push(newItem);
  }
}

/**
 * Método para gestionar el estado de carga y abrir o cerrar el modal de carga.
 *
 * Este método establece el valor de la propiedad `isLoading` con el valor recibido en `isLoading`.
 * Si el estado de carga es verdadero, se abre el modal de carga con la información del payload almacenado en `localStorage`.
 * Si el estado de carga es falso, se cierra el modal.
 *
 * @isLoading -> valor booleano que indica si está en proceso de carga o no.
 */
_onLoading(isLoading: boolean) {
  this.isLoading = isLoading;

  if (this.isLoading) {
    this.openModalLoading(JSON.parse(localStorage.getItem('payload')));
  } else {
    this.modalLoadingOpen = false;
    this.dialog.closeAll();
  }
}

openModalLoading(data: any) {
  // Verificación por variable
  if (this.modalLoadingOpen) {
    return;
  }

  // Verificación por ID
  const existingModal = this.dialog.getDialogById('loadModal');
  if (existingModal) {
    return;
  }

  this.modalLoadingOpen = true;

  var dialogRef = this.dialog.open(ModalLoadingComponent, {
    width: '650px',
    id: "loadModal",
    data: data,
    disableClose: true
  });

  dialogRef.afterClosed().subscribe(() => {
    this.modalLoadingOpen = false;
  });
}

/**
 * Método para establecer el resultado de una pestaña seleccionada.
 *
 * Este método se encarga de asignar el resultado correspondiente a una categoría seleccionada.
 * Dependiendo del valor de `selected`, el método verificará si ya existen resultados previamente
 * cargados y, si no es así, cargará los resultados utilizando el payload adecuado.
 *
 * @selected -> valor que representa la categoría seleccionada, como 'TOURS', 'HOTELS' o 'TRANSPORTS'.
 */
setResultTab(selected: string) {
  switch (selected) {
    case Procesed.TOURS:
      if (this.resultsMultidestinations.resultsTours !== undefined) {
        this._results = this.resultsMultidestinations.resultsTours;
      } else {
        const payload = this.payloadCategory.payloadTours !== undefined ? this.payloadCategory.payloadTours : this.loadPayloadTours(this._payload);
        this.loadResult(selected, payload);
      }
      break;
    case Procesed.HOTELS:
      if (this.resultsMultidestinations.resultsHotel !== undefined) {
        this._results = this.resultsMultidestinations.resultsHotel;
      } else {
        this.payloadCategory.payloadHotel = this._payload;
        this.loadResult(selected, this._payload);
      }
      break;
    case Procesed.TRANSPORTS:
      if (this.resultsMultidestinations.resultsTransport !== undefined) {
        this._results = this.resultsMultidestinations.resultsTransport;
      } else {
        this.verifiResult();
        this.payloadCategory.payloadTransport = this._payloadTransport;
        this.loadResult(selected, this._payloadTransport);
      }
      break;
  }
}

/**
 * Método para verificar los resultados y añadir los destinos que no están en el payload de transporte.
 *
 * Este método compara los destinos de `_payload` con los de `_payloadTransport` para encontrar los destinos
 * que aún no han sido incluidos en el array de transporte. Si se encuentran destinos que no están en el array
 * de transporte, se añaden mediante el método `_loadPayloadTransport`.
 */
verifiResult() {
  const array = [];
  for (let i = 0; i < this._payload.length; i++) {
    let igual = false;
    for (let j = 0; j < this._payloadTransport.length && !igual; j++) {
      if (this._payload[i]['destination'] === this._payloadTransport[j]['origin']) {
        igual = true;
      }
    }
    if (!igual) {
      array.push(this._payload[i]);
    }
  }
  array.forEach(element => {
    this._loadPayloadTransport(this._payload, element.destination);
  });
}


/**
 * Método para inicializar los resultados de multidestinos.
 *
 * Este método establece los valores iniciales de `resultsMultidestinations`, donde las propiedades
 * `resultsHotel`, `resultsTours` y `resultsTransport` se inicializan como `undefined`.
 */
initResultsMultidestination() {
  this.resultsMultidestinations = {
    resultsHotel: undefined,
    resultsTours: undefined,
    resultsTransport: undefined
  };
}

/**
 * Método para inicializar la categoría de payload para multidestinos.
 *
 * Este método establece los valores iniciales de `payloadCategory`, donde las propiedades
 * `payloadHotel`, `payloadTours` y `payloadTransport` se inicializan como `undefined`.
 */
initPayloadCategoryMultidestination() {
  this.payloadCategory = {
    payloadHotel: undefined,
    payloadTours: undefined,
    payloadTransport: undefined
  };
}

setArrivalAndDeparture(response:any, payload:any){
  response.results.forEach(cars => {
    cars.dateIni = payload[0].arrivalDate;
    cars.dateEnd = payload[0].departureDate;
  });
}

/**
 * Método para realizar una búsqueda en el endpoint.
 *
 * Este método gestiona la carga de resultados al realizar una solicitud al servidor.
 * Si la categoría en el payload es '7', se carga un paquete temporal. Si no, realiza
 * una solicitud HTTP POST con el payload para obtener los resultados. En ambos casos,
 * los resultados se almacenan en `_results`.
 *
 * Además, maneja el estado de carga mostrando un modal mientras se realiza la búsqueda,
 * y muestra mensajes de error en caso de no encontrar resultados o si ocurre un error en la solicitud.
 *
 * @category -> nombre de la categoría para la cual se están buscando resultados (como 'HOTELS', 'TOURS', etc.).
 * @payload -> un array de objetos con los parámetros de búsqueda que serán enviados en la solicitud.
 */
async loadResult(category: string, payload: any[], navbarSearch?: boolean) {
  this.isLoading = true;

  if  ((this.isLoading)) {
      this.openModalLoading(JSON.parse(localStorage.getItem('payload')));
  }

  if (payload[0].categoriesId[0] == '7') {  // temporal 12/10/2020
    // Cargar paquete temporal
    this._results[0] = PACKAGES;
    this._results[0].qtyPax = payload[0].qtyPax;
    this._results[0].others = payload[0].others;
    this._results[0].destination = payload[0].destination;
    this._results[0].payload = payload[0];
    this._results[0].categoryName = category;
  } else { // fin temporal
    if (payload !== undefined && payload.length > 0) {
      this.resultsSearch._setPayload(payload);

      this._restService.doPost('app', 'search', payload[0]).subscribe({
        next: (response: any) => {

          // console.log('payload', this._payload[0]);
          if(Array.isArray(response)){
            const initialState: ModalOptions = {
              initialState: {
                message: '',
                confirmText: 'Cerrar',
                cancelText: 'Volver a intentar',
                showCancelButton: true,
                size: 'sm',
              }
            };
           if (!this.bsModalRef || !this.modalService.getModalsCount()) {
             const modalOptions = Object.assign({}, initialState, this.config);
              this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);

              this.bsModalRef.content.confirmResult.subscribe((result) => {

                if(result) {
                  this.loadResult(category, payload, navbarSearch);
                } else {
                  this.onRestoreDataResultsPreviousSearch();
                  this.dialog.closeAll();
                  this._router.navigate(['/home']);
                }
              })

            } else {
            }
          }

          if(category === 'FLIGHTS') {

            response.results = response.results.flights;
          }

         if (response !== null && response.results && Array.isArray(response.results) && response.results.length > 0) {
            this._results = [];
            this._results[0] = response.results;
            this._results[0].qtyPax = payload[0].qtyPax;
            this._results[0].others = payload[0].others;
            this._results[0].destination = payload[0].destination;
            this._results[0].arrivalDate = payload[0].arrivalDate;
            this._results[0].payload = payload[0];
            this._results[0].categoryName = category;
            this._payload = payload;
            this.isLoading = false;
            // this.resultsSearch._setOrigin(origin);
            // this.resultsSearch._setResponse(this._results);
            // this.emitterNewResults();
            // this.modalRef.hide();
            if(this._origin === 'FLIGHTS') {
              this.initializeFlightsData();
            }
            this._setSearchIdInResults(response);
            this.initializeInformationMap(this._results);
            if(category == 'RENT-A-CAR'){
              this.setArrivalAndDeparture(response, payload);
            }
            this.reloadSearching = false;
            this.dialog.closeAll();

            // if(category === '') {
            //   this.reloadSearching = false;
            // }


            if(this._payload[0].categoriesId[0] === 1 && navbarSearch) {

                   this.openModalResearch = false;
                   setTimeout(() => {


                    // this.categoryResult.finishReload = false;
                    // this.categoryResult.reloadAgainSubject.next(false);
                    this.categoryResult.researchPaxList(payload, false,false);
                    // this.categoryResult.payload = payload[0];
                   }, 100);

            }
          } else {
            const initialState: ModalOptions = {
              initialState: {
                message: '',
                confirmText: 'Cerrar',
                cancelText: 'Volver a intentar',
                showCancelButton: true,
                size: 'lg',
              }
            };

          if (!this.bsModalRef || !this.modalService.getModalsCount()) {
              const modalOptions = Object.assign({}, initialState, this.config);
              this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);

              this.bsModalRef.content.confirmResult.subscribe((result) => {

                if(result) {
                  this.loadResult(category, payload, navbarSearch);
                } else {
                    this.onRestoreDataResultsPreviousSearch();
                    this.dialog.closeAll();
                }
              })

            } else {
            }
          }
        },
        error: (error: HttpErrorResponse ) => {
          console.log(error)
          const initialState: ModalOptions = {
            initialState: {
              message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo'
            }
          };

          this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
          const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
            if(result) {
                this.loadResult(category, payload);
              } else {
                  this.onRestoreDataResultsPreviousSearch();
                  this.dialog.closeAll();

            }
            confirmSubscription.unsubscribe();
          });
        }
      });
    }
  }
}

onRestoreDataResultsPreviousSearch(): void {

  const restored = this.restorePayloadService.restorePayload();
  const cateogyId: number = restored?.payload[0].categories[0];
  const restoredOrigin = this.getOrigin(cateogyId);

  localStorage.setItem('payload', JSON.stringify(restored?.payload));
  localStorage.setItem('form', JSON.stringify(restored?.form));
  localStorage.setItem('origin', restoredOrigin);

  switch(cateogyId) {

    case 1:

      localStorage.setItem('hotel_room_state', JSON.stringify(restored?.dataCategory?.hotel_room_state));

      break;
    case 8:

    const oneWay: boolean = restored?.payload[0].transfers.oneWay;

    if(!oneWay) {

      localStorage.setItem('returnTransferForm', JSON.stringify(restored?.dataCategory?.returnTransferForm));
      localStorage.setItem('returnTransferPayload', JSON.stringify(restored?.dataCategory?.returnTransferPayload));


    }

    localStorage.setItem('transport_assignment', JSON.stringify(restored?.dataCategory?.transport_assignment));
    localStorage.setItem('wayTransfer', JSON.stringify(restored?.dataCategory?.wayTransfer));

    break;
  }



}

  /**
 * Método para emitir una nueva búsqueda de resultados.
 *
 * Este método toma un evento, lo asigna a `_payload`, y actualiza el payload de búsqueda
 * en `resultsSearch` con el nuevo evento. Luego, realiza una nueva búsqueda de resultados
 * para la categoría 'HOTELS'.
 *
 * @event -> El evento que contiene los datos necesarios para realizar la búsqueda.
 */
_emitReSearch(event: any) {
  this._payload = event;
  this.resultsSearch._setPayload(event);
  // Use `_origin` from the service as the source of truth for the active
  // category. The previous hard-coded 'HOTELS' would silently mis-route
  // any non-hotel re-search (e.g. transports, flights) — the bug surfaced
  // when the head-band kept showing the previous category's flight form
  // because the wrong result loader had run.
  this.loadResult(this.resultsSearch._getOrigin(), this.resultsSearch._getPayload());
}

/**
 * Método para asignar los resultados de búsqueda a la categoría correspondiente.
 *
 * Este método se encarga de asignar los resultados de búsqueda (`_results`) a las propiedades
 * adecuadas dentro de `resultsMultidestinations` según la categoría proporcionada.
 *
 * @category -> La categoría para la que se asignan los resultados ('TOURS', 'HOTELS', 'TRANSPORTS').
 */
setObject(category: string) {
  switch (category) {
    case Procesed.TOURS:
      this.resultsMultidestinations.resultsTours = this._results;
      break;
    case Procesed.HOTELS:
      this.resultsMultidestinations.resultsHotel = this._results;
      break;
    case Procesed.TRANSPORTS:
      this.resultsMultidestinations.resultsTransport = this._results;
      break;
  }
}

/**
 * Método para cargar el payload para la categoría 'TOURS'.
 *
 * Este método toma un array de objetos de tipo `pay`, y construye un array de objetos `payloadTours`
 * que se utilizarán para realizar las solicitudes correspondientes a la categoría 'TOURS'.
 * Cada objeto dentro del array `payloadTours` contiene información detallada sobre el tour, como el origen,
 * destino, fechas de llegada y salida, y otros detalles relevantes.
 *
 * @pay -> Un array de objetos con los datos de los tours para los cuales se va a generar el payload.
 * @returns Un array de objetos `payloadTours` listos para su uso en la solicitud de búsqueda.
 */
loadPayloadTours(pay: any): any[] {
  var payloadTours = [];
  if (pay !== undefined && pay.length > 0) {

    pay.forEach(element => {
      const pax = this.getPaxList(element);

      const payload = {
        providersId: element.providersId,
        categoriesId: [6],
        origin: element.origin,
        destination: element.destination,
        priceFrom: 0,
        priceTo: 20000,
        arrivalDate: element.arrivalDate,
        departureDate: element.departureDate,
        qtyProduct: 1,
        qtyPax: element.qtyPax,
        others: {
          maxRequestTimeOnSeconds: 20,
          maxNumResultsPerAdapter: "",
          tours: pax
        }
      };
      payloadTours.push(payload);
    });
    this.payloadCategory.payloadTours = payloadTours;
  }
  return payloadTours;
}

/**
 * Método para cargar el payload para la categoría 'TRANSPORTS'.
 *
 * Este método toma un array de objetos de tipo `pay`, y para cada objeto, si el destino coincide con el valor
 * proporcionado en `des`, genera un objeto `payload` para la categoría 'TRANSPORTS'. Este payload contiene
 * detalles sobre el transporte, como el tipo de vehículo, hora de recogida y entrega, y la lista de pasajeros.
 *
 * @pay -> Un array de objetos con los datos de transporte para los cuales se va a generar el payload.
 * @des -> El destino que se utiliza para filtrar los elementos de `pay`.
 * @returns Un array de objetos `payloadTransport` listos para su uso en la solicitud de búsqueda.
 */
_loadPayloadTransport(pay: any, des: any): any[] {
  if (pay !== undefined && pay.length > 0) {
    pay.forEach(element => {
      if (des === element.destination) {
        const pax = this.getPaxList(element);
        const payload = {
          providersId: null,
          categoriesId: [8],
          origin: element.origin,
          destination: element.destination,
          priceFrom: null,
          priceTo: null,
          arrivalDate: element.arrivalDate,
          departureDate: element.departureDate,
          qtyProduct: 1,
          qtyPax: element.qtyPax,
          others: {
            maxRequestTimeOnSeconds: 20,
            minNumResults: 3,
            maxNumResultsPerAdapter: "",
            transfers: {
              transferType: 'Regular / Premium',
              pickupTime: "01:00",
              dropoffTime: "01:00",
              pickupLocation: {
                id: "MCO-",
                type: "airport",
                providerId: "c9f2c93e-ca2a-4546-8ade-8978f93adb75",
                nameAdapter: "Hotel_Beds_Address"
              },
              dropoffLocation: {
                id: "540005",
                type: "hotel",
                providerId: "c9f2c93e-ca2a-4546-8ade-8978f93adb75",
                nameAdapter: "Hotel_Beds_Address"
              },
              paxList: pax,
              vehiclesDist: [
                pax
              ],
              oneWay: false
            }
          }
        };
        this._payloadTransport.push(payload);
      }
    });
  }
  return this._payloadTransport;
}

/**
 * Método para cargar el payload para la categoría 'TRANSPORTS'.
 *
 * Este método toma un array de objetos `pay`, y para cada objeto, genera un objeto `payload` para la categoría 'TRANSPORTS'.
 * El payload contiene información detallada sobre el transporte, incluyendo el origen, destino, fechas, y detalles del tipo de transporte
 * como el tipo de vehículo, hora de recogida y entrega, y la lista de pasajeros.
 *
 * @pay -> Un array de objetos con los datos de transporte para los cuales se va a generar el payload.
 * @returns Un array de objetos `payloadTransport` listos para su uso en la solicitud de búsqueda.
 */
loadPayloadTransport(pay: any): any[] {
  var payloadTransport = [];
  if (pay !== undefined && pay.length > 0) {
    pay.forEach(element => {
      const pax = this.getPaxList(element);
      const payload = {
        providersId: null,
        categoriesId: [8],
        origin: element.origin,
        destination: element.destination,
        priceFrom: null,
        priceTo: null,
        arrivalDate: element.arrivalDate,
        departureDate: element.departureDate,
        qtyProduct: 1,
        qtyPax: element.qtyPax,
        others: {
          maxRequestTimeOnSeconds: 20,
          minNumResults: 3,
          maxNumResultsPerAdapter: "",
          transfers: {
            transferType: 'Regular / Premium',
            pickupTime: "01:00",
            dropoffTime: "01:00",
            pickupLocation: {
              id: "MCO",
              type: "airport",
              providerId: "c9f2c93e-ca2a-4546-8ade-8978f93adb75",
              nameAdapter: "Hotel_Beds_Address"
            },
            dropoffLocation: {
              id: "540005",
              type: "hotel",
              providerId: "c9f2c93e-ca2a-4546-8ade-8978f93adb75",
              nameAdapter: "Hotel_Beds_Address"
            },
            paxList: pax,
            vehiclesDist: [
              pax
            ],
            oneWay: false
          }
        }
      };
      payloadTransport.push(payload);
    });
    this.payloadCategory.payloadTransport = payloadTransport;
  }
  return payloadTransport;
}

/**
 * Método para obtener la lista de pasajeros (adults y children) de un objeto de tipo `element`.
 *
 * Este método procesa la propiedad `others.hotels.roomConfiguration` dentro del `element` para calcular el número total
 * de adultos y los niños en las habitaciones configuradas. El resultado es un objeto con el número de adultos y los niños
 * por cada habitación.
 *
 * @element -> El objeto que contiene la información de configuración de habitaciones y otros detalles relevantes.
 * @returns Un objeto con las propiedades `adults` (número de adultos) y `children` (lista de niños).
 */
getPaxList(element: any): any {
  var children = [];
  var adults = 0;
  if (element.others !== undefined && element.others !== null) {
    element.others.hotels.roomConfiguration.forEach(room => {
      adults += parseInt(room.adults);
      children = room.children;
    });
  }
  return { adults, children };
}

/**
 * Método para obtener el payload de una categoría específica.
 *
 * Este método obtiene el payload correspondiente a una categoría ('TOURS', 'TRANSPORTS', 'HOTELS') dependiendo
 * del valor de `categoryName`. Si la categoría ya tiene un payload almacenado, devuelve el valor almacenado, de lo contrario,
 * genera un nuevo payload llamando al método correspondiente (como `loadPayloadTours` o `loadPayloadTransport`).
 *
 * @categoryName -> El nombre de la categoría para la cual se obtiene el payload ('TOURS', 'TRANSPORTS', 'HOTELS').
 * @index -> El índice del payload dentro de la categoría solicitada.
 * @returns El payload correspondiente a la categoría y el índice proporcionado.
 */
getPayloadCategory(categoryName: string, index: number) {
  let payload;
  if (this._origin === Procesed.MULTIDESTINATION) {
    switch (categoryName) {
      case Procesed.TOURS:
        payload = this.payloadCategory.payloadTours !== undefined ? this.payloadCategory.payloadTours[index] : this.loadPayloadTours(this._payload)[index];
        break;
      case Procesed.TRANSPORTS:
        payload = this.payloadCategory.payloadTransport !== undefined ? this.payloadCategory.payloadTransport[index] : this.loadPayloadTransport(this._payload)[index];
        break;
      case Procesed.HOTELS:
        payload = this.payloadCategory.payloadHotel !== undefined ? this.payloadCategory.payloadHotel[index] : this._payload[index];
        break;
      default:
        payload = this._payload[index];
    }
  } else {
    payload = this._payload[index];

  }
  return payload;
}

  /**
 * Método que obtiene un objeto de carga desde el servicio `serviceItinerary` y realiza un `subscribe`.
 * Este método puede ser utilizado para controlar el estado de carga en la interfaz de usuario.
 * Actualmente, la línea que actualiza la variable `isLoading` está comentada, pero puede ser utilizada
 * para mostrar un indicador de carga en el UI según el valor recibido en la respuesta.
 *
 * @returns Ninguno. Solo se realiza una suscripción al observable del servicio.
 */
loading() {
  this.serviceItinerary.getLoadingObject().subscribe((response: any) => {
    //this.isLoading = Boolean(response); // Descomentar si se necesita controlar el estado de carga
  });
}

/**
 * Método que establece el `searchId` en los resultados de búsqueda.
 *
 * Este método recibe un objeto `response` que contiene los resultados y un `searchId`.
 * Luego, agrega el `searchId` a cada uno de los resultados en el array `response.results`.
 *
 * @response -> Objeto que contiene los resultados de búsqueda y un `searchId` asociado.
 * @returns Ninguno. Modifica los resultados de búsqueda en su lugar.
 */
_setSearchIdInResults(response: any) {
  [ response.results ].forEach(obj => {
    obj.searchId = response.searchId;
  });
}

/**
 * Método que abre un modal con una clase personalizada.
 *
 * Este método utiliza `modalService` para abrir un modal y le asigna una clase CSS personalizada (`'gray modal-lg'`).
 * La clase se pasa como parte de las configuraciones adicionales, además de cualquier otra configuración
 * que pueda estar definida en `this.config`.
 *
 * @template -> Plantilla `TemplateRef` que se va a mostrar en el modal.
 * @returns Ninguno. Muestra el modal utilizando `modalService`.
 */
openModalWithClass(template: TemplateRef<any>) {
  this.multiModal = true;
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, this.config, { class: 'gray modal-lg' })
  );
}

/**
 * Método que cambia entre pestañas en función de la pestaña seleccionada.
 *
 * Este método maneja la lógica para cambiar de pestaña en la interfaz de usuario. Según el valor de
 * `this._tabSelected`, el método redirige a una nueva pestaña (por ejemplo, 'HOTELS', 'TRANSPORTS', 'SUMMARY').
 *
 * @event -> Evento que se pasa al método, aunque no se utiliza directamente en este caso.
 * @returns Ninguno. Realiza una redirección a otra pestaña basada en el valor de `this._tabSelected`.
 */
changeTab(event) {
  switch (this._tabSelected) {
    case 'HOTELS':
      this._redirectTo('TRANSPORTS');
      break;

    case 'TRANSPORTS':
      this._redirectTo('TOURS');
      break;

    case 'SUMMARY':
      this._redirectTo('SUMMARY');
      break;

    default:
      break;
  }
}


productDeleteEmitter(event: any) {
  switch (this._payload[0].categoriesId[0]) {
    case 1:
      if(this.qtyProductValid < this._payload[0]?.qtyProduct) {
        this.qtyProductValid = this.qtyProductValid + 1;
      }
      break;
    }

  this.deleteProduct = 'delete-product';
}





  _onMultimodal(event){

  }

  reloadItinerary(): void {
    this.serviceItinerary.consultActiveItinerary(this.userService._agentID, false, this.itinerary?.id, 'reloadItinerary');
    this.openModalFly = false;
  }

  onItemRemove(item: any): void {
    if (this.isRemovingItem) return;
    this.isRemovingItem = true;
    this.serviceItinerary.remove(item.item !== undefined ? item.item : item, null);
    setTimeout(() => { this.isRemovingItem = false; }, 1000);
  }

  openModalFlyCreate(): void {
    this.openModalFly = true;
  }


modifiedTransportPriceSelectedReturn(event: boolean): void {
  this.eventModifiedTransportPriceSelectedReturn = true;
}


reloadEmmit(): void {
  this.setItinerary();
}

rentacarAcriss(event:any){
  this.arrayFilterAcriss = event;
}

selectFilterAcriss(event:any, type:any){


  if(this.selectedAcrissKey == type){
    this.selectedAcrissKey = null;
    this.CategoryResultComponent.clearFilter();
    return
  }


  this.selectedAcrissKey = type;
  this.CategoryResultComponent.clearFilter();
  this.CategoryResultComponent.filterAcriss(event.target.checked, type);

}

// isDisabledFilter(carAcriss):boolean{
//   return this.selectedAcrissKey !== null && this.selectedAcrissKey !== carAcriss.key;
// }

emitterNewResults(): void {
    this._results = [];
    this._results = this.resultsSearch._getResponse();

    this._payload = this.resultsSearch._getPayload();
    this._origin = this.resultsSearch._getOrigin();
    this._form = JSON.parse(localStorage.getItem('form'));

    this.initResultsMultidestination();
    this.initPayloadCategoryMultidestination();

    if(this._origin === 'TRANSPORTS') {
      this.formTransports = JSON.parse(localStorage.getItem('form'));
    }

    if (this._origin === Procesed.MULTIDESTINATION) {
      this._tabSelected = Procesed.HOTELS;
      this.resultsFound = true;
    } else {
      if (this._results !== undefined && this._results !== null) {
        // eslint-disable-next-line max-len
        this.resultsFound = this._results[0] !== undefined ? this._results[0]['noResultMessage'] !== undefined ? false : true : this._results['noResultMessage'] !== undefined ? false : true;
      }
    }
    if (this._results !== undefined) {
      for (let index = 0; index < this._results.length; index++) {
        this.isCollapsed[index] = true;
      }
     }

  if(this._payload[0].categoriesId[0] === 1) {

      this.openModalResearch = false;
      setTimeout(() => {
      this.categoryResult.researchPaxList(this._payload, false,false);
      this.suggestionComponent.getSuggestionsBig();
        }, 100);
      }
}

reloadEditPencilEmitter(): void {
  const payload = JSON.parse(localStorage.getItem('payload'));

  if(payload) {
    const categoryPayload = payload[0].categoriesId[0];
    if(categoryPayload) {
      const categoryNameOpenModal = this.getCategoryName(categoryPayload);
      if(categoryNameOpenModal) {
        this.openFormSearch(categoryNameOpenModal);
      }
    }
  }
}

getCategoryName(categoryId: number): string {

  switch(categoryId) {
    case 1: return 'Alojamiento';
    case 2: return 'Rent a car';
    case 5: return 'FLIGHTS';
    case 6: return 'Experiencia';
    case 8: return 'Traslado';
    case 9: return 'Tickets';
    case 10: return 'Asistencia';
  }
}


  openFormSearch(modalSearch: string): void {
    this.openModalResearch = true;
    let dialogRef: any;
    const payload = JSON.parse(localStorage.getItem('payload'));
    const form = JSON.parse(localStorage.getItem('form'));

    switch (modalSearch) {
      case 'Alojamiento':
          localStorage.setItem('origin', 'HOTELS')
          dialogRef = this.dialog.open(HotelsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          maxHeight: '90vh',
          panelClass: 'hotels-dialog',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 1,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para hotel


        break;

      case 'Rent a car':
        dialogRef = this.dialog.open(RentcarsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 2,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para rent a car
        break;

      case 'Experiencia':
         dialogRef = this.dialog.open(ActivitiesComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 6,
                  idActivity: 6,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para tours
        break;

      case 'Traslado':
          dialogRef = this.dialog.open(TransportsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {
                  clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 8,
                  payload: payload,
                  formTransport: form
                }
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para traslado

        break;

      case 'Multidestino':
         this.dialog.open(MultiDestinationComponent, {
          width: '85%',
          height: 'auto',
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para multidestino
        break;

      case 'Tickets':
        dialogRef = this.dialog.open(ActivitiesComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 9,
                  idActivity: 9,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para tours
        break;



      case 'Paquetes':
        // this.dialog.open(PackagesComponent, {
        //   width: '85%',
        //   height: 'auto',
        //   // data: { option: 'hoteles' } // lo que necesites pasar
        // });
        // lógica para paquetes
        break;

      case 'Asistencia':
         dialogRef = this.dialog.open(InsuranceComponent, {
            width: '85%',
          height: 'auto',
          minHeight: '320px',
          maxHeight: '90vh',
          panelClass: 'insurance-dialog',
          data: {
                    clientSetting: this.getClientsSettingAppBooking,
                    component: 'results',
                    category: 10,
                    payload: payload,
                    form: form // lo que necesites pasar
        }
        });
        // lógica para asistencia
        break;

      default:
        console.warn('Categoría no reconocida:', modalSearch);
        break;
    }

    if(dialogRef) {
      dialogRef.afterClosed().pipe(
        take(1)
        ).subscribe((payload) => {
          if(payload) {
            this.reloadSearching = true;
            this._payload = JSON.parse(localStorage.getItem('payload'));
            this._origin = localStorage.getItem('origin');
            this.categoryId = this._payload?.[0]?.categoriesId?.[0];
            if(this.categoryId === 1) {
              this._form = JSON.parse(localStorage.getItem('form'));
              this.getQtyProductValid();
              this.hotelService.initializeSelection(this._form.room);
            }
            if(this.categoryId === 8) {
              this.formTransports = JSON.parse(localStorage.getItem('form'));
              // this.transportsService.initializeAssignment(this._payload[0].transfers.paxList);
            }
              this.buttons?.forEach((button: ElementRef, index: number) => {
              this.renderer.setStyle(button.nativeElement, 'border', 'none');
              this.renderer.setStyle(button.nativeElement, 'color', 'none');
              this.renderer.setStyle(button.nativeElement, 'background-color', this.styleSidebar?.background_color);
            });
            // this.buttonActiveResearch();
            this.loadResult(this._payload[0].categoriesId[0], [payload], true);



            // this._results = this.resultsSearch._getResponse();
          } else {
            return;
          }
        })
    }
  }

    initializeInformationMap(source?: any[]): void {
      const resultsSource = source ?? this._results;

      switch(this._origin) {
        case 'HOTELS':
    if(resultsSource && resultsSource.length > 0) {

      this.coordinatesArr = resultsSource[0]
        .map((result: any) => {
          return {
            coordinates: result.coordinates,
            hotel_name: result.title,
            address: result.additionalInfo?.location,
            cancellationPolicies: result.additionalInfo?.rooms[0]?.room?.cancellationPolicy,
            priceUnitary: result.additionalInfo?.rooms[0]?.room?.netPriceProf,
            price: result.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf,
            boardName: result.additionalInfo?.rooms[0]?.room?.boardName,
            images: result.additionalInfo?.images,
            rateClass: result.additionalInfo?.rooms[0].room?.rateClass,
            views: result.view_hotel,
            id: result.id,
            starRating: Number.parseInt(result.additionalInfo.starRating),
            currency: result.additionalInfo?.rooms[0]?.room?.pricing?.currency,
            generalMap: true,
            origin: this._origin
          };
        })
        .filter((hotel: any) => {
          // Filtrar hoteles con coordenadas válidas (no 0,0)
          return hotel.coordinates &&
                 hotel.coordinates.latitude !== 0 &&
                 hotel.coordinates.longitude !== 0 &&
                 parseFloat(hotel.coordinates.latitude) !== 0 &&
                 parseFloat(hotel.coordinates.longitude) !== 0;
        });
    }
    break;

 case 'TOURS':
   if (resultsSource && resultsSource.length > 0) {

    const subCategory = this._payload[0].categoriesId[0];
    this.coordinatesArr = resultsSource[0]
      .map((result: any) => {


        if(result.additionalInfo.images && result.additionalInfo.images.length > 0) {
          result.additionalInfo.images[0]['is_cover'] = 1;
        }

        return {
          coordinates: result.additionalInfo?.location_gps,
          hotel_name: result.title,
          address: result.additionalInfo?.location,
          rateClass: result.additionalInfo?.tours?.options[0]?.rateClass,
          cancellationPolicies: this.getCancellationPoliciesMap(result.additionalInfo?.tours?.options[0], subCategory) ,
          price: result.additionalInfo?.tours?.options[0]?.profility.find(c => c.paxType === 'ADULT')?.netPriceBooking,
          images: result.additionalInfo?.images,
          views: result.views,
          id: result.productId,
          currency: result?.additionalInfo?.currency,
          generalMap: true,
          origin: this._origin
        };
      })
      .filter((tour: any) => {
        // DEBUG: Ver qué coordenadas tiene cada tour

        if (!tour.coordinates) {
          return false;
        }

        const latStr = tour.coordinates.latitude;
        const lngStr = tour.coordinates.longitude;

        // Convertir a número (manejar strings vacíos, null, undefined)
        const latNum = parseFloat(latStr);
        const lngNum = parseFloat(lngStr);
        // Verificar que sean números válidos y no sean 0
        const isValid = !isNaN(latNum) &&
                       !isNaN(lngNum) &&
                       latNum !== 0 &&
                       lngNum !== 0;
        return isValid;
      });
  }
  break;
    case 'TRANSPORTS':

    this.pickupLocation = {
      lat: Number(this._payload[0].transfers?.pickupLocation?.latitude) ?? null,
      lng: Number(this._payload[0].transfers?.pickupLocation?.longitude) ?? null,
      name: this._payload[0].transfers?.pickupLocation?.name,
      iata: this._payload[0].transfers?.pickupLocation?.origin,
      type: this._payload[0].transfers?.pickupLocation?.type,
      country_code: this._payload[0].transfers?.pickupLocation?.origin,

    }

    this.dropoffLocation = {
      lat: Number(this._payload[0].transfers?.dropoffLocation?.latitude) ?? null,
      lng: Number(this._payload[0].transfers?.dropoffLocation?.longitude) ?? null,
      name: this._payload[0].transfers?.dropoffLocation?.name,
      iata: this._payload[0].transfers?.dropoffLocation?.destination,
      type: this._payload[0].transfers?.dropoffLocation?.type,
      country_code: this._payload[0].transfers?.dropoffLocation?.destination,
    }

    break;
      }
    }

getCancellationPoliciesMap(option: any, subCategory: number): any[] {
    // Validación inicial
    if (!option) {
        console.warn('Option es null o undefined');
        return [];
    }

    let cancellationArr: any[] = [];

    try {
        switch(subCategory) {
            case 6:
                // Validación para caso 6
                if (option?.cancellationPolicies?.[0]?.cancellationPolicies) {
                    const policies = option.cancellationPolicies[0].cancellationPolicies;
                    cancellationArr = Array.isArray(policies) ? policies : [];
                } else {
                    console.warn('No se encontraron cancellationPolicies para subCategory 6');
                }
                break;

            case 9:
                // Validación para caso 9
                if (option?.availableDates?.[0]?.cancellationPolicies) {
                    const policies = option.availableDates[0].cancellationPolicies;
                    cancellationArr = Array.isArray(policies) ? policies : [];
                } else {
                    console.warn('No se encontraron cancellationPolicies para subCategory 9');
                }
                break;

            default:
                console.warn(`subCategory ${subCategory} no manejado`);
                return [];
        }
    } catch (error) {
        console.error('Error al obtener cancellationPolicies:', error);
        return [];
    }

    return cancellationArr;
}

selectProductFromMap(event: any): void {
  this.viewMap = false;
  if (this.categoryResult) {
    this.categoryResult.viewMapsResult = false;
  }

  setTimeout(() => {
    if (this.categoryResult?.containerResults) {
      const componentes = this.categoryResult.containerResults.toArray();
      const product = this._results[0].find(c => c.productId === event);

      switch(this._payload[0].categoriesId[0]) {
        case 1:
          const primerComponente = componentes[0] as unknown as BaseResultComponent;

          if (primerComponente && product) {
            primerComponente.result = product;
            primerComponente.openModal(primerComponente.ModalRooms, 'rooms');
          }
        break;
        case 6:
        case 9:

          const primerComponenteTours = componentes[0] as unknown as BaseResultComponent;

          if (primerComponenteTours && product) {
            primerComponenteTours.result = product;
            primerComponenteTours.openModal(primerComponenteTours.modalTours, 'tour');
          }
          break;
      }

    }
  }, 0);

}

openModalResearchEmmit(event: boolean): void {
  console.log(event);
  // this.openModalResearch = !this.openModalResearch;
}
}
